export const CUSTOMER_CARE_MODALS_NAMES = {
  cancellationModal: 'cancellationModal',
}
